import lazyLoad from 'app/shared-components/util/lazyLoad';
import BookingConfig from '../booking/BookingConfig';

const ProfileView = lazyLoad(() => import('./ProfileView'));


const ProfileViewConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: 'profile/:id',
      element: <ProfileView />,
    },
    ...BookingConfig.routes.map(route => ({
      ...route,
      path: `profile/:id/${route.path}`
    }))
  ],
};

export default ProfileViewConfig;


